import { ElementComponentProps } from "elements/types";
import { extractOnApplyParameters } from "elements/utils";
import React from "react";
import { TextInputElement } from "records/Element";
import TextInputSingleOnApply from "./TextInputSingleOnApply";
import TextInputSingleReactive from "./TextInputSingleReactive";

const TextInputSingle = (props: ElementComponentProps<TextInputElement>) => {
	const { isOnApplyPropsProvided, requiredOnApplyProps } =
		extractOnApplyParameters(props);
	return isOnApplyPropsProvided ? (
		<TextInputSingleOnApply {...props} {...requiredOnApplyProps} />
	) : (
		<TextInputSingleReactive {...props} />
	);
};

export default React.memo(TextInputSingle);
